import React from 'react'

const Gallery = () => {
    return (
        <div className="mt-16 p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {Array.from({ length: 74 }, (_, i) => (
                <a
                    key={i}
                    href={`./IMG-20250718-WA00${i + 19}.jpg`}
                    target='_blank'
                >
                    <img

                        src={`IMG-20250718-WA00${i + 19}.jpg`}
                        alt={`Gallery ${i + 1}`}
                        className="w-full aspect-video object-contain rounded shadow hover:scale-105 transition-transform duration-300"
                        loading="lazy"
                    />
                </a>
            ))}
        </div>
    )
}

export default Gallery
